module.exports = __webpack_public_path__ + "img/weidu3.1ad415b5.png";